/** ISO 8601 date string (YYYY-MM-DD). Branded for type safety. */
export type ISODateString = string & { readonly __brand: 'ISODateString' };

/** Tworzy ISODateString z stringa. Rzuca jeśli format niepoprawny. */
export function isoDate(value: string): ISODateString {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    throw new Error(`Invalid ISO date: "${value}", expected YYYY-MM-DD`);
  }
  return value as ISODateString;
}

/** Dzisiejsza data jako ISODateString */
export function today(): ISODateString {
  return new Date().toISOString().split('T')[0] as ISODateString;
}
